import {
  SegmentedGroup,
  SegmentedGroupItem,
} from '@repo/ui/components/segmented-group'
import { useTranslate } from '@repo/shared/hooks'
import type { OrderBoxPriceTypeTabsProps } from './order-box.types'

export const OrderBoxPriceTypeTabs = ({
  priceType,
  onChange,
}: OrderBoxPriceTypeTabsProps) => {
  const { t } = useTranslate()
  return (
    <SegmentedGroup
      value={priceType}
      onValueChange={onChange}
      size='md'
      className='w-full'
    >
      <SegmentedGroupItem value='limit' className='flex-1'>
        {t('order_limit')}
      </SegmentedGroupItem>
      <SegmentedGroupItem value='market' className='flex-1'>
        {t('order_market')}
      </SegmentedGroupItem>
    </SegmentedGroup>
  )
}
